import { PorfolioAssetsTable } from "./PortfolioAssetsTable";
interface PortfolioAssetListProps {
  assetData: any;
  isSwap?: boolean;
  desktop?: boolean;
  balances: any[];
  setLinkClickedLoading?: (boolean) => void;
}
export const DTPortfolioAssetsList = ({
  assetData,
  balances,
  isSwap,
  setLinkClickedLoading
}: PortfolioAssetListProps) => {
  return <table className="w-full ta-r mb-[80px] " data-sentry-component="DTPortfolioAssetsList" data-sentry-source-file="DTPortfolioAssetsList.tsx">
            <thead>
                <tr className="bg-genius-blue text-[14px]">
                    <td className="px-5 py-2">Ticker</td>
                    <td className="py-2 ta-r">Balance</td>
                    <td className="py-2 ta-r">Price</td>
                    <td className="px-4 py-2 ta-r">Returns</td>
                    <td className="px-4 py-2 ta-c"></td>
                </tr>
            </thead>

            {balances?.filter((x: any) => x?.contract_address).filter(x => x.usd_value > 0).sort((a: any, b: any) => b.usd_value - a.usd_value).map((assetItem: any, index: number) => <PorfolioAssetsTable key={index} isSwap={isSwap} setLinkClickedLoading={setLinkClickedLoading} assetItem={assetItem} assetData={assetData} />)}
        </table>;
};